const VERSION = "2.1.0";
export {
  VERSION
};
